import React, { useState, useReducer, useEffect } from "react";
import {
  Alert,
  Card,
  Col,
  Row,
  Table,
  Badge,
  Image,
  Button,
  Modal,
} from "react-bootstrap";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import axios from "../../../../../config/axios";
import moduleConfig from "../../moduleConfig";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import { ContainerLoading } from "../../../../UI/loading/ContainerLoading";
// import GalleryItem from "./GalleryPicture";
import ReactFancyBox from "react-fancybox";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
// import AddFossilPicture from "./AddFossilPicture";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";

import parse from "html-react-parser";
import {
  detailsReducer,
  detailsInitialState,
} from "../../../../../reducers/module/detailsReducer";
import GalleryPictures from "../../../../UI/shared/gallery/GalleryPictures";
import { FaFileAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
const Details = ({ item, detailsDispatch, loadItem, loading }) => {
  const getItems = () => {
    let items = [];

    if (item.email) {
      items = [
        ...items,
        {
          text: "Email",
          value: item.email,
          type: "email",
        },
      ];
    }
    if (item.mobile) {
      items = [
        ...items,
        {
          text: "mobile",
          value: item.mobile,
          type: "phone",
        },
      ];
    }
    if (item.employmentType) {
      items = [
        ...items,
        {
          text: "Notice Period",
          value: item.noticePeriod,
          type: "number",
        },
      ];
    }

    return items;
  };
  const getItems2 = () => {
    let items = [];

    if (item?.job?.title) {
      items = [
        ...items,
        {
          text: "title",
          value: item?.job?.title,
          type: "text",
        },
      ];
    }
    if (item?.job?.joiningTime) {
      items = [
        ...items,
        {
          text: "joiningTime",
          value: item?.job?.joiningTime,
          type: "text",
        },
      ];
    }
    if (item?.job?.employmentType) {
      items = [
        ...items,
        {
          text: "employmentType",
          value: item?.job?.employmentType,
          type: "number",
        },
      ];
    }
    if (item?.job?.salary) {
      items = [
        ...items,
        {
          text: "salary",
          value: item?.job?.salary,
          type: "number",
        },
      ];
    }
    return items;
  };
  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex align-items-center ImageSectionSpacing">
                  <div className="me-2 ms-1">
                    <FaFileAlt size={30} />
                  </div>

                  <div className="d-flex flex-column ms-1 mt-1">
                    <span className="m-0 text-bold memberName text-red">
                      {item.firstName + " " + item.lastName}
                    </span>

                    <span className="">
                      <span className="text-custom-4 mt-1 small ">
                        Applied for -{" "}
                        <span className="text-custom-3 text-bold">
                          "{item.job.title}"
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </Card.Title>

              <div className="card-tools">
                <div className=" text-right   pt-0">
                  {item.appliedDate && (
                    <span className="badge badge-light me-1 text-dark">
                      Applied Date :{" "}
                      <span className="text-secondary">
                        <ModuleDisplayDate value={item.appliedDate} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>

            <Card.Body className="px-1 pt-1 pb-0">
              <Row className="gy-2">
                <Col className="mt-1 mb-0">
                  <StatsListing items={getItems()} />

                  {item.message && (
                    <Alert className="alert-custom-3 d-flex mb-1 flex-wrap p-1 font-small">
                      <strong className="me-1 mt-1 text-custom-1">
                        Message:
                      </strong>
                      <div className="d-flex align-items-center flex-wrap p-1 font-small">
                        <span
                          className="font-small text-normal text-custom-1 html"
                          dangerouslySetInnerHTML={{ __html: item.message }}
                        />
                      </div>
                    </Alert>
                  )}
                </Col>

                <Col xl={4} className="mb-1">
                  <Link
                    to={`/jobs/${item?.job?._id}`}
                    className="text-decoration-none"
                  >
                    <div className="bg-custom-4 text-white rounded-4 p-4 shadow-sm-sm transition-all hover:shadow-lg hover:-translate-y-1">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="fw-semibold mb-0">
                          Applied Job Details
                        </h5>
                        <i className="fas fa-arrow-right text-white-50"></i>
                      </div>

                      <div className="border-top border-white border-opacity-25 pt-3">
                        <StatsListing items={getItems2()} />
                      </div>
                    </div>
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
